import { Row, Col } from 'antd';
import React, { ReactElement, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store';
import { GUTTOR_SPACE } from '../../constants/commonConstants';
import FormFormattedAmount from '../crmFormElement/FormFormattedAmount/FormFormattedAmount';
import { FormTextInput } from '../crmFormElement/FormInput';
import { NewAdmissionState } from '../../../store/models/newAdmissionModel';
import { getIsPageNameDetail } from '../../../modules/crm/inPatient/service/crmUtils';
import FormTextArea from '../crmFormElement/FormTextArea/FormTextArea';
import FormAutoCompleteWithPrefix from '../crmFormElement/FormAutoComplete/FormAutoCompleteWithPrefix';
import { useLocation } from 'react-router-dom';
import CONTROL_CONFIG_BASED_ON_PAYER from '../../../config/formControlConfig';
import { isEmpty } from 'lodash';
import { updateDefaultTimeline } from '../../../store/actions/newAdmissionAction';
const SettlementCard = ({ form, newFileUploads }: any): ReactElement => {
  const { claimDetails: { inPatientNo: inPatientNumber = '' } = {} } = useSelector((state: RootState): any =>
    state?.admissionDetails || {});
  const { payerList: { payer: { shortName, name, uniqueIdentifier  } } } =
    useSelector((state: RootState): RootState => state);
  const { isDraftSelected } = useSelector((state: RootState): any => state.newAdmission);
  const {
    modalFormValue,
  } = useSelector((state: RootState): NewAdmissionState => state.newAdmission);
  const inPatientNo = inPatientNumber || modalFormValue?.inPatientNumber;
  const {
    payerLookUp = {},
  } = useSelector((state: RootState): RootState => state);
  const isSettlementEnabledRPAPayer = ['ICICI', 'VIDAL', 'FHPL', 'Bajaj', 'PHSI', 'SHAI'].includes(shortName);
  const { doctorList = [] } = payerLookUp[uniqueIdentifier] || {};
  const { pathname } = useLocation();
  const payerConfig = CONTROL_CONFIG_BASED_ON_PAYER[name];
  const visibleForSettlement = payerConfig?.doctorQualification?.visibleForSettlement ?? false;
  const { hospitalSearchPatientDetails } = useSelector((state: RootState): any => state.hospital);
  const commonDetail = { form };
  const defaultTimeline = useSelector((state: RootState): any => state?.newAdmission?.defaultTimeline || {});
  const dispatch = useDispatch();
  const patientDetails = hospitalSearchPatientDetails?.[0] || {};

  useEffect((): void => {
    if (!isEmpty(patientDetails)) {
      form.setFieldsValue({ doctorName: patientDetails?.doctorDetails?.doctorName });
    }
  }, [patientDetails]);

    useEffect((): void => {
      if (!isDraftSelected && !inPatientNo) {
        form?.resetFields(['inPatientNumber']);
      } else {
        form?.setFieldsValue({ inPatientNumber: inPatientNo });
      }
    }, [inPatientNo]);

  const onChangeRemarks = (event: any): any => {
    defaultTimeline.remarks['Remarks for document upload'] = event.target.value;
    dispatch(updateDefaultTimeline(defaultTimeline));
  };

  return (
    <React.Fragment>
      <Row gutter={GUTTOR_SPACE}>
        <Col span={12} className="no-pdf-l no-pdg-rt ">
          {
            shortName === 'SHAI' &&
            <FormFormattedAmount detail={{
              ...commonDetail,
              key: 'claimedAmount',
              required: true,
              addonBefore: '₹ ',
              placeholder: 'Enter Claimed Amount',
              allowNegative: false,
              allowClear: true,
              hidden: false,
            }} />
          }
          {
            shortName !== 'SHAI' &&
            <FormFormattedAmount detail={{
              ...commonDetail,
              key: 'patientPaidAmount',
              label: 'Patient paid amount',
              required: !isSettlementEnabledRPAPayer,
              disabled: false,
              addonBefore: '₹ ',
              allowClear: true,
              allowNegative: false,
              isShowSuggestedValue: true,
            }} />
          }
        </Col>
        <Col span={12} className="no-pdf-l no-pdg-rt ">
          <FormTextInput detail={{
            ...commonDetail,
            key: 'inPatientNumber',
            label: 'Inpatient No.',
            required: !isSettlementEnabledRPAPayer,
            disabled: (shortName === 'RGI' || shortName === 'ABHI') ? inPatientNo : false,
            labelClass: 'mb-0',
            onlyAlphaNumeric: true,
            suffixTestId: 'settlement',
            isShowSuggestedValue: true,
          }} />
        </Col>
      </Row>
      <Row gutter={GUTTOR_SPACE}>
        <Col span={12} className="no-pdf-l no-pdg-rt ">
          <FormTextInput detail={{
            ...commonDetail,
            key: 'recieptNo',
            label: 'Receipt No.',
            required: !isSettlementEnabledRPAPayer,
            disabled: false,
            isShowSuggestedValue: true,
          }} />
        </Col>
        <Col span={12} className="no-pdf-l no-pdg-rt">
          {visibleForSettlement && (
            <FormAutoCompleteWithPrefix
              detail={{
                ...commonDetail,
                key: 'doctorName',
                options: doctorList,
                isName: true,
                isPrefixRequired: true,
                showSearch: true,
                hidden: false,
                className: 'doctorClass',
                isDetailPage: getIsPageNameDetail(pathname),
                prefix: 'Dr. ',
                isShowSuggestedValue: true,
              }}
            />
          )}
        </Col>
      </Row>
      <Row gutter={GUTTOR_SPACE}>
        <Col span={12} className="no-pdf-l no-pdg-rt ">
          {visibleForSettlement && <FormTextInput
            detail={{
              ...commonDetail,
              key: 'doctorQualification',
              hidden: false,
              disabled: false,
            }}
          />}
        </Col>
      </Row>
      <Row gutter={GUTTOR_SPACE}>
        <FormTextArea detail={{
          ...commonDetail,
          key: 'fileUploadRemark',
          label: 'Remarks',
          required: shortName === 'CARE',
          placeholder: 'Please enter your remarks',
          size: 24,
          onChange: onChangeRemarks,
          disabled: false,
          isShowSuggestedValue: true,
        }}
        />
      </Row>
    </React.Fragment>
  );
};

export default SettlementCard;
